import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import measurement from 'utils/measurement';
import { WatermarkState } from '../types';

export function getWatermark(
  config: PodcastTemplateConfig,
): [WatermarkState, boolean] {
  const firstWatermark = config?.watermark?.[0];
  if (!firstWatermark) return [undefined, undefined];

  return [
    {
      position: {
        left: measurement(firstWatermark.position?.properties?.left),
        top: measurement(firstWatermark.position?.properties?.top),
      },
      size: {
        height: measurement(firstWatermark.style?.height),
        width: measurement(firstWatermark.style?.width),
      },
      integrationData: undefined,
      metadata: undefined,
      originalUrl: firstWatermark.url,
      url: firstWatermark.url,
    },
    firstWatermark.imageType === 'mainImage',
  ];
}
